import "./app.css";

import { mount } from "svelte";

import App from "./App.svelte";

const app = document.getElementById("app");
if (!app) throw new Error("App mount element not found");
const appMount = mount(App, {
    target: app,
});

export default appMount;
